import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpUserEvent, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth/services/auth.service';
import { environment } from '../environments/environment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  private readonly appApi: string;

  /**
   * Constructor
   *
   * @param {Router} router
   * @param {AuthService} authService
   * @param {Meta} meta
   */
  public constructor(
    private router: Router,
    private authService: AuthService,
    private meta: Meta,
  ) {
    const apiMeta = this.meta.getTag('name=application-api');
    this.appApi = apiMeta.content;
  }

  /**
   * Intercept every request response, if the response is a 403, we do a logout
   *
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   *
   * @return {Observable<HttpEvent<any>>}
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any> | HttpUserEvent<any> | any> {
    const updatedRequest = request.clone({url: this.appApi + request.url});
    return next.handle(updatedRequest)
    .pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          if (request.url.includes('game')) {
              return this.router.navigate(['/', 'course']);
          } else if (!request.url.includes('oauth')) {
            this.authService.doLogout().subscribe();
          }
        }
        return throwError(error);
      }),
    );
  }
}
